import React from 'react';
import { AlertTriangle, Users } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Progress } from '@/components/ui/progress';

const WARNING_LABELS = { onder_min: 'Onder minimum', boven_max: 'Boven maximum' };
const WARNING_STYLES = {
  onder_min: 'border-amber-200 bg-amber-50 text-amber-800',
  boven_max: 'border-red-200 bg-red-50 text-red-700',
};

const memberLoadLabel = (member) => {
  const count = member.count_this_month || 0;
  if (member.max != null) return `${count} / ${member.max} gepland`;
  if (member.target != null) return `${count} / ${member.target} gepland`;
  if (member.min != null) return `${count} / ${member.min} minimum`;
  return `${count} gepland`;
};

const progressValue = (member) => {
  const limit = member.max ?? member.target ?? member.min;
  if (!limit || limit < 1) return null;
  return Math.min(100, ((member.count_this_month || 0) / limit) * 100);
};

const RosterTeamLoad = ({ members = [], overrides = [] }) => (
  <div className="space-y-4">
    <div>
      <h2 className="text-base font-semibold text-slate-900">Teambelasting</h2>
      <p className="mt-1 text-sm text-slate-500">Verdeling deze maand</p>
    </div>
    <section className="border border-slate-200 bg-white" aria-label="Teambelasting per teamlid">
      {members.length ? members.map((member, index) => {
        const progress = progressValue(member);
        const warning = WARNING_LABELS[member.status];
        return (
          <div key={member.user_id} className={`px-4 py-3.5 ${index ? 'border-t border-slate-100' : ''}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="truncate font-medium text-slate-900">{member.name}</p>
                <p className="mt-0.5 text-sm text-slate-500">{memberLoadLabel(member)}</p>
                {(member.min != null || member.target != null || member.max != null) && (
                  <p className="mt-1 text-xs text-slate-400">
                    {[member.min != null && `min ${member.min}`, member.target != null && `streef ${member.target}`, member.max != null && `max ${member.max}`].filter(Boolean).join(' · ')}
                  </p>
                )}
              </div>
              {warning && <Badge variant="outline" className={`shrink-0 gap-1 ${WARNING_STYLES[member.status]}`}><AlertTriangle className="h-3 w-3" />{warning}</Badge>}
            </div>
            {progress != null && <Progress value={progress} className="mt-3 h-1.5 bg-slate-100 [&>div]:bg-teal-600" aria-label={`Voortgang ${member.name}`} />}
          </div>
        );
      }) : (
        <div className="px-5 py-8 text-center">
          <Users className="mx-auto h-7 w-7 text-slate-300" />
          <p className="mt-2 text-sm text-slate-500">Geen teamleden ingepland deze maand.</p>
        </div>
      )}
    </section>
    {!!overrides.length && (
      <div className="border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
        <p className="font-medium">Overruled conflicten deze maand</p>
        <ul className="mt-1 list-inside list-disc space-y-1 text-amber-800">
          {overrides.map((override) => <li key={`${override.reference_id}-${override.user_id}-${override.created_at}`}>{override.reason || 'Geen reden opgegeven'}</li>)}
        </ul>
      </div>
    )}
  </div>
);

export default RosterTeamLoad;

